export class AuthRoutes {
  public static readonly LOGIN = '/uas/portal/auth/login';
  public static readonly LOGOUT = '/uas/portal/auth/logout';
  public static readonly FORGET_PASSWORD = '/uas/portal/auth/forgot';
  public static readonly TWO_FACTOR_LOGIN = '/uas/portal/auth/mfa';
  public static readonly ERROR = '/uas/portal/auth/error';
  public static readonly RESET_PASSWORD = '/uas/portal/auth/reset';
  public static readonly RESET_PASSWORD_SUCEESS = '/uas/portal/auth/reset-success';
  public static readonly MAINATENANCE_NOTICE = '/uas/portal/maintenance-notice';
  public static readonly SAML_ERROR = '/uas/portal/saml-error';
  public static readonly CHALLENGE_EXPIRY_ROUTE = '/uas/portal/auth/challenge-expiry';
  public static readonly CHANGE_PASSWORD = '/uas/portal/auth/change-password';
  public static readonly DISABLE_NOTICE = '/uas/portal/disable-notice';
  public static readonly NEED_HELP = 'https://greythr.com/greythr-help';
}
